class SDHomeSlider {
  constructor(root) {
    this.root = root;
    this.track = root.querySelector('[data-sd-track]');
    this.slides = [...root.querySelectorAll('[data-sd-slide]')];
    this.dots = [...root.querySelectorAll('[data-sd-dot]')];
    this.index = 0;
    this.startX = 0;
    this.timer = null;
    if (!this.track || this.slides.length < 1) return;

    root.querySelector('[data-sd-prev]')?.addEventListener('click', () => this.go(this.index - 1, true));
    root.querySelector('[data-sd-next]')?.addEventListener('click', () => this.go(this.index + 1, true));
    this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.go(index, true)));
    this.track.addEventListener('pointerdown', (event) => { this.startX = event.clientX; });
    this.track.addEventListener('pointerup', (event) => {
      const distance = event.clientX - this.startX;
      if (Math.abs(distance) > 45) this.go(this.index + (distance < 0 ? 1 : -1), true);
    });
    root.addEventListener('mouseenter', () => this.stop());
    root.addEventListener('mouseleave', () => this.start());
    document.addEventListener('visibilitychange', () => document.hidden ? this.stop() : this.start());
    this.go(0);
    this.start();
  }

  go(index, restart = false) {
    this.index = (index + this.slides.length) % this.slides.length;
    this.track.style.transform = `translate3d(-${this.index * 100}%, 0, 0)`;
    this.slides.forEach((slide, slideIndex) => slide.setAttribute('aria-hidden', slideIndex === this.index ? 'false' : 'true'));
    this.dots.forEach((dot, dotIndex) => dot.setAttribute('aria-current', dotIndex === this.index ? 'true' : 'false'));
    if (restart) { this.stop(); this.start(); }
  }

  start() {
    if (this.root.dataset.autoplay !== 'true' || this.slides.length < 2 || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const delay = Math.max(3000, Number(this.root.dataset.interval || 5) * 1000);
    this.timer = window.setInterval(() => this.go(this.index + 1), delay);
  }

  stop() {
    if (this.timer) window.clearInterval(this.timer);
    this.timer = null;
  }
}

function initSDHomeSliders(scope = document) {
  scope.querySelectorAll('[data-sd-slider]').forEach((slider) => {
    if (!slider.sdSlider) slider.sdSlider = new SDHomeSlider(slider);
  });
}

document.addEventListener('DOMContentLoaded', () => initSDHomeSliders());
document.addEventListener('shopify:section:load', (event) => initSDHomeSliders(event.target));
